



























import Vue from 'vue';
import Component from 'vue-class-component';
import { tickets } from '@/modules/shared/shared/store/namespaces';
import { getFullDate, getDate } from '@/modules/shared/shared/domain/functions/date-functions';

@Component
export default class PDTComments extends Vue {
    setFormatDate(date: string): string {
        return getDate(date);
    }

    get items() {
        const items = this.ticketDetail.accessPermission.workflowAccessPermissionsStates.filter(
            i => i.comment !== null,
        );
        const distinctComments = [...new Set(items.map(i => i.comment))];
        const distinctObject = distinctComments.map(comment => {
            return items.find(j => j.comment === comment);
        });

        return distinctObject;
    }

    @tickets.State('ticketDetail') ticketDetail;
}
